import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import pt from 'react-phone-number-input/locale/pt-BR';


/**
 * Style.
 */
import './phone.scss';

const Phone = ({
  white,
  label,
  input,
  meta,
  ...field
}) => (
  <div className="textfield-wrapper">
    <div className={classNames('textfield-label', { white })}>{label}</div>
    <PhoneInput
      labels={pt}
      {...input}
      {...field}
      className={classNames('textfield-input', {
          'has-error': meta.touched && meta.error,
        })}
      onBlur={() => input.onBlur(input.value)}
    />
    {meta.touched && meta.error && (
    <div>
      <span className="error-span">{meta.error}</span>
    </div>
      )}
  </div>
  );

Phone.propTypes = {
  label: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  white: PropTypes.bool,
  meta: PropTypes.object,
};

Phone.defaultProps = {
  white: false,
  meta: {},
};

export default Phone;
